export default "__VITE_ASSET__0f2615df__"